// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ImportCreateJobSchema = z.object({
  job: z.object({
    workspace_id: z.optional(z.number().int().describe("Workspace ID to import from")),
    project_ids: z.optional(z.array(z.number().int()).describe("Project IDs to import")),
  }),
});
